import script from "./SignupPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SignupPage.vue?vue&type=script&setup=true&lang=js"

import "./SignupPage.vue?vue&type=style&index=0&id=45406f37&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45406f37"]])

export default __exports__